import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  SHORTENER_RESOLUTION_CLEAR,
  SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
  SHORTENER_RESOLUTION_CLOSE_LINK,
  SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_REQUEST,
} from '../../../actions/actionTypes';

const closeLink = fetchReducerGenerator(
  [
    SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
    SHORTENER_RESOLUTION_CLEAR,
    SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_REQUEST,
  ],
  SHORTENER_RESOLUTION_CLOSE_LINK
);

export default closeLink;

export const getShortenerResolutionCloseLinkIsSuccess = state =>
  state.response && state.response.status === HttpStatus.NO_CONTENT.value;
